export class Setor {
  constructor ({
    id,
    descricao,
  } = {
    id: '',
    descricao: '',
  }) {
    this.id = id
    this.descricao = descricao
  }
}

export function createSetor (data) {
  return Object.freeze(new Setor(data))
}
